const { createFeatureFlagSwitch } = require('lib/featureFlagSwitch');

export const { hook: useIsGeoRestrictedEnabled } = createFeatureFlagSwitch({
  key: 'live-player-geo-restricted',
  name: 'omega',
});
